/* Lea Versailles - UpCart: cor e tamanho em linhas separadas.
   O UpCart escreve "Couleur: Camel, Taille: XS" num unico <span>.
   Este script esconde esse span e mostra cada opcao numa linha,
   como no carrinho de referencia (14px, linha de 26,5px).
   O span original fica no DOM para o UpCart (React) o continuar a
   atualizar; quando o texto muda, as linhas sao refeitas. */
(function () {
  'use strict';

  var SEL = '.upcart-public-component-product-tile__variant';
  var CSS =
    '.lea-var-orig{display:none !important;}' +
    '.lea-var-lines{display:block;}' +
    '.lea-var-line{display:block;font-size:14px;line-height:26.5px;}';

  function partir(txt) {
    // parte so nas virgulas seguidas de "Nome:" (nao parte valores com virgula)
    return txt.split(/,\s*(?=[^,:]+:)/).map(function (s) { return s.trim(); }).filter(Boolean);
  }

  function processar(root) {
    var boxes = root.querySelectorAll(SEL);
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      var orig = null;
      for (var c = 0; c < box.children.length; c++) {
        if (!box.children[c].classList.contains('lea-var-lines')) { orig = box.children[c]; break; }
      }
      if (!orig) continue;
      var txt = (orig.textContent || '').trim();
      var linhas = box.querySelector(':scope > .lea-var-lines');
      if (partir(txt).length < 2) {
        orig.classList.remove('lea-var-orig');
        if (linhas) linhas.remove();
        continue;
      }
      if (linhas && linhas.getAttribute('data-src') === txt) continue;
      if (!linhas) {
        linhas = document.createElement('div');
        linhas.className = 'lea-var-lines';
        box.appendChild(linhas);
      }
      linhas.setAttribute('data-src', txt);
      linhas.textContent = '';
      partir(txt).forEach(function (p) {
        var s = document.createElement('span');
        s.className = 'lea-var-line';
        s.textContent = p;
        linhas.appendChild(s);
      });
      orig.classList.add('lea-var-orig');
    }
  }

  function ligar(root) {
    if (root.__leaVar) return;
    root.__leaVar = true;
    var st = document.createElement('style');
    st.textContent = CSS;
    root.appendChild(st);
    var agendado = false;
    new MutationObserver(function () {
      if (agendado) return;
      agendado = true;
      requestAnimationFrame(function () { agendado = false; processar(root); });
    }).observe(root, { childList: true, subtree: true, characterData: true });
    processar(root);
  }

  function procurar() {
    var host = document.getElementById('upCart');
    if (host && host.shadowRoot) { ligar(host.shadowRoot); return true; }
    return false;
  }

  if (!procurar()) {
    var n = 0;
    var t = setInterval(function () {
      if (procurar() || ++n > 120) clearInterval(t);
    }, 500);
  }
})();
